import { takeEvery, put, fork } from "redux-saga/effects";
import * as api from "../../api/SingleMaintenanceUpdateApi";
import * as actions from "../actions/SingleMaintenanceUpdateActions";
import { showSuccessSnackbar, showErrorSnackbar } from "../actions/SnackbarActions";
import { setBackdrop, resetBackdrop } from "../actions/BackdropActions";

import moment from "moment";

function* downloadSchema() {
    yield put(resetBackdrop());
    const { data } = yield api.downloadSchema();
    const url = window.URL.createObjectURL(new Blob([data]));
    const link = document.createElement("a");
    link.href = url;
    const filename = "MOST_Single_Maintenance_" + moment(new Date()).format("DD_MM_YYYY_HH_mm_ss") + ".xlsx"; //name with date time & extension
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    yield put(setBackdrop());
}

function* downloadExamples(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.downloadExamples(action.payload);
        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement("a");
        link.href = url;
        const filename = "MOST_Single_Maintenance_" + moment(new Date()).format("DD_MM_YYYY_HH_mm_ss") + ".xlsx"; //name with date time & extension
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
    } catch (error) {
        yield put(showErrorSnackbar(error, "error"));
    }
    yield put(setBackdrop());
}

function* excelToListSingle(action) {
    yield put(resetBackdrop());
    try {
        //Bu metot iki kere istek atiyor. Enteresan bir hata. Cozmek icin if kullanildi ama kotu bir cozum oldu
        if (action.payload.data) {
            const { data } = yield api.excelToListSingle(action.payload.data);
            yield put(actions.excelToListSingle(data || undefined));
        }
    } catch (error) {
        yield put(showErrorSnackbar(error, "error"));
    }
    yield put(setBackdrop());
}

function* uploadExcel(action) {
    try {
        const hashCode = action.payload;
        const { data } = yield api.excelUpload(hashCode);
        yield put(actions.uploadExcelFileResponse(data));
        yield put(showSuccessSnackbar(data.message));
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
}

function* watchAll() {
    yield takeEvery(actions.Types.DOWNLOAD_SCHEMA, downloadSchema);
    yield takeEvery(actions.Types.EXCEL_TO_LIST_SINGLE_MAINTENANCE, excelToListSingle);
    yield takeEvery(actions.Types.UPLOAD_EXCEL, uploadExcel);
    yield takeEvery(actions.Types.DOWNLOAD_EXAMPLES, downloadExamples);
}

const SingleMaintenanceUpdateSaga = [fork(watchAll)];

export default SingleMaintenanceUpdateSaga;
